<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <router-link :to="{name: 'Home'}" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </router-link>
        <a href="javascript:void(0);" class="link-title">Enquiry Details</a>
      </nav>
    </div>
    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-7">
                                    <span class="lead-title" v-if="GetEnquiriesDetails.full_name">{{GetEnquiriesDetails.full_name}}</span>
                                    <span class="sub-title" v-if="GetEnquiriesDetails.enquiry">{{GetEnquiriesDetails.enquiry}}</span>
                                </div>
                                <div class="col-5 text-right" v-if="GetEnquiriesDetails.status">
                                    <span class="label-status">{{GetEnquiriesDetails.status}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6" v-if="GetEnquiriesDetails.assigned_to">
                                    <span class="enq-title">Assigned to</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.assigned_to}}</span>
                                </div>
                                <div class="col-6" v-if="GetEnquiriesDetails.rm">
                                    <span class="enq-title">RM</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.rm}}</span>
                                </div>
                                <div class="col-6" v-if="GetEnquiriesDetails.ncd">
                                    <span class="enq-title">NCD</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.ncd}}</span>
                                </div>
                                <div class="col-6" v-if="GetEnquiriesDetails.firm_name">
                                    <span class="enq-title">Broker</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.firm_name}}</span>
                                </div>
                                <div class="col-6" v-if="GetEnquiriesDetails.is_nri">
                                    <span class="enq-title">Is NRI</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.is_nri}}</span>
                                </div>
                                <div class="col-6" v-if="GetEnquiriesDetails.created_at">
                                    <span class="enq-title">Created at</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.created_at}}</span>
                                </div>
                                <div class="col-12" v-if="GetEnquiriesDetails.comment">
                                    <span class="enq-title">Description</span>
                                    <read-more more-str="read more"  :text="GetEnquiriesDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer" v-if="roleId!=11">
                            <div class="row">
                                <div class="col-md-12 call-loading-holder">
                                    <img width="100%" height="auto"  v-bind:src="CallStatus === 'dialing' ? PhoneCall.dialing : CallStatus === true ? PhoneCall.connected: CallStatus === false ? PhoneCall.failed: ''">
                                </div>
                               <div class="col-6 text-center">
                                <span class="projectName"  v-if="!showPhone" @click="showMobileNo()">
                                  <svg width="24" height="24" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0_9493_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                                    <rect x="0.11377" y="0.489624" width="16" height="16" fill="#D9D9D9"/>
                                    </mask>
                                    <g mask="url(#mask0_9493_7)">
                                    <path d="M8.11524 10.8743C8.87068 10.8743 9.5123 10.6099 10.0401 10.0811C10.5679 9.55235 10.8317 8.91024 10.8317 8.15479C10.8317 7.39935 10.5673 6.75773 10.0386 6.22996C9.50979 5.70218 8.86768 5.43829 8.11224 5.43829C7.3568 5.43829 6.71518 5.70268 6.18741 6.23146C5.65963 6.76024 5.39574 7.40235 5.39574 8.15779C5.39574 8.91323 5.66013 9.55485 6.18891 10.0826C6.71768 10.6104 7.35979 10.8743 8.11524 10.8743ZM8.11374 9.95629C7.61374 9.95629 7.18874 9.78129 6.83874 9.43129C6.48874 9.08129 6.31374 8.65629 6.31374 8.15629C6.31374 7.65629 6.48874 7.23129 6.83874 6.88129C7.18874 6.53129 7.61374 6.35629 8.11374 6.35629C8.61374 6.35629 9.03874 6.53129 9.38874 6.88129C9.73874 7.23129 9.91374 7.65629 9.91374 8.15629C9.91374 8.65629 9.73874 9.08129 9.38874 9.43129C9.03874 9.78129 8.61374 9.95629 8.11374 9.95629ZM8.11374 12.823C6.71029 12.823 5.42674 12.4486 4.26307 11.6998C3.09941 10.9511 2.17057 9.96612 1.47657 8.74479C1.42102 8.64901 1.38041 8.55251 1.35474 8.45529C1.32918 8.35807 1.31641 8.25829 1.31641 8.15596C1.31641 8.05362 1.32918 7.95396 1.35474 7.85696C1.38041 7.75996 1.42102 7.66357 1.47657 7.56779C2.17057 6.34646 3.09941 5.36146 4.26307 4.61279C5.42674 3.86401 6.71029 3.48962 8.11374 3.48962C9.51718 3.48962 10.8007 3.86401 11.9644 4.61279C13.1281 5.36146 14.0569 6.34646 14.7509 7.56779C14.8065 7.66357 14.8471 7.76007 14.8727 7.85729C14.8983 7.95451 14.9111 8.05429 14.9111 8.15662C14.9111 8.25896 14.8983 8.35862 14.8727 8.45562C14.8471 8.55262 14.8065 8.64901 14.7509 8.74479C14.0569 9.96612 13.1281 10.9511 11.9644 11.6998C10.8007 12.4486 9.51718 12.823 8.11374 12.823ZM8.11374 11.823C9.36929 11.823 10.5221 11.4924 11.5721 10.8313C12.6221 10.1702 13.4249 9.27851 13.9804 8.15629C13.4249 7.03407 12.6221 6.1424 11.5721 5.48129C10.5221 4.82018 9.36929 4.48962 8.11374 4.48962C6.85818 4.48962 5.70541 4.82018 4.65541 5.48129C3.60541 6.1424 2.80263 7.03407 2.24707 8.15629C2.80263 9.27851 3.60541 10.1702 4.65541 10.8313C5.70541 11.4924 6.85818 11.823 8.11374 11.823Z" fill="#1C1B1F"/>
                                    </g>
                                    </svg>
                                </span>
                                  <a v-else  @click="GetEnquiriesDetails.ctoc_enabled ? makeCall(GetEnquiriesDetails.id)  : dial(GetEnquiriesDetails.phone)">
                                    <div>
                                    <span class="icon icon-call">
                                        <img src="@/assets/phone.svg" alt="">
                                    </span>
                                    </div>
                                  </a>
                                  <span class="enq-title">Mobile Number</span>
                                </div>
                                <div class="col-6 text-center">
                                  <a v-if="GetEnquiriesDetails.email" :href="`mailto:${GetEnquiriesDetails.email}`">
                                    <span class="icon icon-call"> <img src="@/assets/email.svg" alt=""> </span>
                                    <span class="enq-title">Primary Email</span>
                                    <span class="enq-details">{{GetEnquiriesDetails.email}}</span>
                                  </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card details-card">
                        <div class="card-body">
                            <b-tabs content-class="mt-3">
                                <b-tab title="Pistol" active>
                                    <div class="row">
                                        <div class="col-12" v-if="GetEnquiriesDetails.status">
                                            <span class="enq-title">Enquiry Status</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.status}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.ncd">
                                            <span class="enq-title">Next Action Date </span>
                                            <span class="enq-details">{{GetEnquiriesDetails.ncd}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.assigned_to">
                                            <span class="enq-title">Assigned to</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.assigned_to}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry">
                                            <span class="enq-title">Enquiry</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.comment">
                                            <span class="enq-title">Enquiry Comment</span>
                                            <read-more more-str="read more"  :text="GetEnquiriesDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Broker">
                                         <div class="row">
                                             <div class="col-12">
                                                 <span class="lead-heading">Enquiry Basic Detail</span>
                                             </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_no">
                                            <span class="enq-title">Enquiry Number</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_no}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.full_name">
                                            <span class="enq-title">Full Name</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.full_name}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.phone && roleId!=11">
                                            <span class="enq-title">Mobile Number</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.phone}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.email">
                                            <span class="enq-title">Primary Email</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.email}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_source">
                                            <span class="enq-title">Enquiry Source</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_source}}</span>
                                        </div>
                                           <div class="col-12" v-if="GetEnquiriesDetails.location">
                                            <span class="enq-title">Location</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.location}}</span>
                                        </div>
                                         <div class="col-12">
                                            <span class="lead-heading">Enquiry Requirement Detail</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.property_type">
                                            <span class="enq-title">Property Type</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.property_type}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.budget">
                                            <span class="enq-title">Maximum Budget </span>
                                            <span class="enq-details">{{GetEnquiriesDetails.budget}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry">
                                            <span class="enq-title">Enquired / Interested For</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_obm_done_date">
                                            <span class="enq-title">OBM Done Date</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_obm_done_date}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_vcm_done_date">
                                            <span class="enq-title">VCM Done Date</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_vcm_done_date}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.visit_date">
                                            <span class="enq-title">Visit Date</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.visit_date}}</span>
                                        </div>
                                         <div class="col-12">
                                            <span class="lead-heading">Enquiry Assignment</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_status">
                                            <span class="enq-title">Enquiry Status</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_status}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.action_date">
                                            <span class="enq-title">Next Action Date</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.action_date}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_assigned_to">
                                            <span class="enq-title">Assigned To</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.enquiry_assigned_to}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.telecaller_name">
                                            <span class="enq-title">TeleCaller</span>
                                            <span class="enq-details">{{GetEnquiriesDetails.telecaller_name}}</span>
                                        </div>
                                        <div class="col-12" v-if="GetEnquiriesDetails.enquiry_comment">
                                            <span class="enq-title">Enquiry Comment</span>
                                              <read-more more-str="read more"  :text="GetEnquiriesDetails.enquiry_comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                  <div class="card-btn">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <router-link :to="{ name: 'EditEnquiry', params: { id: GetEnquiriesDetails.id }}" class="btn btn-primary btn-block"> <img
                             alt="" class="m-fix mr-1" /> Edit
                          Enquiry</router-link>
                      </div>
                      <div class="col-12 mb-3">
                        <router-link :to="{ name: 'AddNewMeeting', params: { id: this.$route.params.id }, query: {name: 'enquiry'}}" class="btn btn-primary btn-block"> <img
                             alt="" class="m-fix mr-1" />
                             Add Meeting</router-link>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Details',
  data() {
    return {
      queryP: {},
      CallStatus: null,
      showPhone: false,
      roleId: localStorage.getItem('radiate-crm-role_id'),
      GetEnquiriesDetails: {},
      PhoneCall: {connected: require('@/assets/connected.gif'), dialing: require('@/assets/dialing.gif'), failed: require('@/assets/failed.gif')}
    }
  },
  created () {
    this.FetchEnquiriesDetails()
  },
  methods: {
    showMobileNo() {
      this.$axios.post(`enquiries_builders/${this.queryP.id}/access_protected_info`)
      .then(res=>{
        this.showPhone = true
      })
      .catch(err=>console.log(err));
    },
    FetchEnquiriesDetails() {
        this.queryP['id'] = this.$route.params.id;
        this.$axios.get(`enquiries_builders/${this.queryP.id}`, { params: this.queryP }).then((res) => {
        this.GetEnquiriesDetails = res.data.enquiry;
        if (this.GetEnquiriesDetails.is_nri === true) {
          this.GetEnquiriesDetails.is_nri = 'Yes'
        } else {
          this.GetEnquiriesDetails.is_nri = 'No'  
        }
        if (this.GetEnquiriesDetails.comment !== null) {
          this.GetEnquiriesDetails.comment = this.GetEnquiriesDetails.comment.replaceAll('\n', '<br>')
        }
      });
    },
    dial(phone) {
      window.location ='tel:'+ phone;
    },
    makeCall(id) {
        this.CallStatus = 'dialing'
        this.$axios.post(`enquiries_builders/make_call`, { id: id }).then((res) => {
          this.CallStatus = res.data.success
      });
    }
  }
}
</script>
<style scoped>
    .inner-page{
        margin-top: 60px;
    }
    .call-loading-holder img{
        max-width: 500px;
        margin:0 auto;
        display: table;
    }
</style>